import type { User } from '@auth0/auth0-react';

const ROLES_CLAIM = 'https://app.creditpulse.com/roles';

export const isSuperAdmin = (user: User | undefined) => {
  const roles = user?.[ROLES_CLAIM] || [];
  return Array.isArray(roles) && roles.includes('SUPER_ADMIN');
};
